import { render, staticRenderFns } from "./supplierFinance.vue?vue&type=template&id=1692abb2"
import script from "./supplierFinance.vue?vue&type=script&lang=js"
export * from "./supplierFinance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports